import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { Reunioes } from "../models/reunioes.model";
import { Observable } from "rxjs";

@Injectable()
export class ReunioesService extends BaseService<Reunioes> {

  constructor(public http: HttpClient) {
    super(http);
  }



  public getListCombos(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list', { headers: this.headers });
  }
  public deleteList(ids: number[]): Observable<any> {
    const params = '?ids[]=' + ids.join('&ids[]=');
    return this.http.delete(this.baseUrl + '/all' + params, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/reuniao/reunioes';
  }
}